const transformRules = [
  {
    oldField: 'Contact us',
    newField: 'Contact us title',
    newSections: ['Show Navigation']
  },
  {
    oldField: 'Order tracking',
    newField: 'Order tracking title',
    newSections: ['Show Navigation']
  },
  {
    oldField: 'Articles',
    newField: '"Article" plural label',
    newSections: ['Show Navigation']
  },
  {
    oldField: 'Categories',
    newField: 'Categories title',
    newSections: ['Show Navigation']
  },
  {
    oldField: 'We are online',
    newField: 'Online status',
    newSections: ['Show Navigation']
  },
  {
    oldField: 'Usually reply in a few minutes',
    newField: 'Offline status',
    newSections: ['Show Navigation']
  },
  {
    oldField: 'Search for help',
    newField: 'Article search placeholder',
    newSections: ['Show Navigation']
  },
  {
    oldField: 'View all',
    newField: '"View all" categories',
    newSections: ['Show Navigation']
  },
  {
    oldField: 'Article',
    newField: '"Article" singular label',
    newSections: ['Show Navigation']
  },
  {
    oldField: 'Type key word to find answer',
    newField: 'FAQ page search placeholder',
    newSections: ['FAQ page']
  },
  {
    oldField: 'Track',
    newField: 'Track button',
    newSections: ['Show Navigation']
  },
  {
    oldField: `Tracking number can't be blank`,
    newField: 'Required tracking number',
    newSections: ['Show Navigation']
  },
  {
    oldField: 'All',
    newField: '"All" tabs in FAQ page',
    newSections: ['FAQ page']
  },
  {
    oldField: 'Frequently Asked Questions',
    newField: 'Heading',
    newSections: ['FAQ page']
  },
  {
    oldField: 'Got a question? We are here to answer!',
    newField: 'Description',
    newSections: ['FAQ page']
  },
  {
    oldField: 'No matching article found',
    newField: 'No matching article found',
    newSections: ['Show Navigation']
  },
  {
    oldField: 'No matching article found',
    newField: '"No matching article found" message',
    newSections: ['FAQ page']
  },
  {
    oldField: 'Hi',
    newField: 'Heading title',
    newSections: ['Show Navigation']
  },
  {
    oldField: 'How can we help you?',
    newField: 'Heading description',
    newSections: ['Show Navigation']
  },
  {
    oldField: 'Chat with us',
    newField: 'Launcher label',
    newSections: ['Show Navigation']
  },
  {
    oldField: 'How can we help you?',
    newField: 'Welcome online message',
    newSections: ['Show Navigation']
  }
];

export function getNewStructure(userTranslation, systemTranslation) {
  const newStructure = {...systemTranslation};
  transformRules.forEach(rule => {
    const {oldField, newField, newSections} = rule;
    if (!userTranslation?.hasOwnProperty(oldField)) return;

    newSections.forEach(section => {
      if (!newStructure.hasOwnProperty(section)) return;
      newStructure[section][newField] = userTranslation[oldField];
    });
  });
  return newStructure;
}
